import React from 'react';
import { FadeIn } from '../ui/FadeIn';
const ITEMS = ["You've tried resin before and it came out sticky, bubbly or just wrong.", "You've spent hours on YouTube tutorials but still feel confused and stuck.", "You want to sell on Etsy or Shopify but don't have a single sell-ready piece yet.", "You're tired of wasting money on supplies that don't work.", 'You want a proven step-by-step system — not another random tutorial.'];
export function ThisIsForYou() {
  return <section className="w-full px-4 md:px-8 max-w-4xl mx-auto flex flex-col items-center" data-id="element-368">
      <FadeIn className="text-center mb-12" data-id="element-369">
        <span className="text-amber font-lato uppercase tracking-widest text-sm font-bold mb-4 block" data-id="element-370">
          This Is For You If...
        </span>
        <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl text-cream" data-id="element-371">
          Sound Like You?
        </h2>
      </FadeIn>

      <FadeIn delay={100} direction="up" className="w-full" data-id="element-372">
        <div className="bg-darkCard border border-darkBorder rounded-2xl p-8 md:p-12" data-id="element-373">
          <div className="flex flex-col gap-6" data-id="element-374">
            {ITEMS.map((item, index) => <div key={index} className="flex items-start gap-4" data-id="element-375">
                <span className="text-amber text-lg flex-shrink-0 mt-0.5" data-id="element-376">
                  ✓
                </span>
                <p className="font-lato text-cream text-base md:text-lg leading-relaxed" data-id="element-377">
                  {item}
                </p>
              </div>)}
          </div>
        </div>
      </FadeIn>
    </section>;
}